export const waterSourcesShortOptions = [
	{ code: "borewell", name: "Borewell" },
	{ code: "supply", name: "Cauvery" },
	{ code: "tanker", name: "Tanker" },
];
